import { VERIFICATION_TYPES } from '@fantaz/shared/app-config';
import {
  CompleteSessionDirectCashierResponse,
  SavePaymentMethodResponse,
  TsevoDirectCashierResponse,
} from '@fantaz/shared/data-access/models';
import { Observable, of } from 'rxjs';

export class MockWalletApiService {
  static savePaymentMethodResponse(): Observable<SavePaymentMethodResponse> {
    return of({
      MerchantID: 'fUHSaCnsmUKRto3PTPZC5w',
      MerchantSessionID: '4qm2go9a6q6lk43voe1p44hbb7',
      ResponseCode: 0,
      ResponseMessage: 'No error.',
      PaymentMethod: {
        Type: 'CC',
        CardNumber: '************8453',
        Network: null,
        ExpirationDate: '12/2028',
        AVSResult: 'ExactMatch',
        CVVResult: 'Match',
        DisplayName: 'x8453',
        FirstSix: '675964',
        LastFour: '8453',
        Token: '79d61931-332f-4af2-aecd-59a42be7c645',
        NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
        BillingAddress: {
          AddressLine1: '123 Greenwood Lane',
          AddressLine2: null,
          City: 'Williston',
          StateCode: 'VT',
          PostalCode: '05495',
          CountryCode: 'US',
        },
        PhoneNumber: null,
      },
      ApiVersion: 3.0,
    } as SavePaymentMethodResponse);
  }

  static getDepositMinLimitResponse(): Observable<TsevoDirectCashierResponse> {
    return of({
      status: 'DEPOSIT_MIN_AMOUNT_LIMIT',
    } as TsevoDirectCashierResponse);
  }

  static getDepositMaxLimitResponse(): Observable<TsevoDirectCashierResponse> {
    return of({
      status: 'DEPOSIT_MAX_AMOUNT_LIMIT',
    } as TsevoDirectCashierResponse);
  }

  static getWithdrawalMinLimitResponse(): Observable<TsevoDirectCashierResponse> {
    return of({
      status: 'WITHDRAWAL_MIN_AMOUNT_LIMIT',
    } as TsevoDirectCashierResponse);
  }

  static getWithdrawalMaxLimitResponse(): Observable<TsevoDirectCashierResponse> {
    return of({
      status: 'WITHDRAWAL_MAX_AMOUNT_LIMIT',
    } as TsevoDirectCashierResponse);
  }

  static getTransactionNotFound(): Observable<TsevoDirectCashierResponse> {
    return of({
      status: 'TRANSACTION_NOT_FOUND',
    } as TsevoDirectCashierResponse);
  }

  static getPaymentSession(): Observable<TsevoDirectCashierResponse> {
    return of({
      Limits: {
        MinAmount: 5,
        MaxAmount: 1000,
      },
      ReasonCodes: [
        'DFP-HR-CONN',
        'DFP-VPRP',
        'LL-ALERT-DIST',
        'LL-BLOCK',
        'LL-BLOCK-BG',
        'LL-GEO-BG',
        'LL-OUT-US',
        'ID-FAIL',
        'ID-UNKN',
      ],
      MerchantSessionID: '63ebb25f-27ba-49c7-ac02-c7463ef22e02',
      PaymentAmounts: [
        {
          PaymentAmount: 0,
          BonusAmount: 0,
          PaymentCurrencyCode: 'USD',
        },
      ],
      PaymentMethods: [
        {
          Type: 'ACH',
          AccountNumber: '***4567',
          RoutingNumber: '999999999',
          BankName: 'TEST BANK',
          DisplayName: 'x4567',
          Token: 'a47def6c-2a03-4c7b-ad22-baf9fd98a033',
          NameOnAccount: 'Norbyn1 Leyva1',
          BillingAddress: {
            AddressLine1: '321 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '************1111',
          Network: 'Visa',
          ExpirationDate: '12/2025',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x1111',
          FirstSix: '411111',
          LastFour: '1111',
          Token: '6fd24a51-f495-46a7-9e6e-efa50b5f2b9b',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '************4444',
          Network: 'MasterCard',
          ExpirationDate: '12/2026',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x4444',
          FirstSix: '555555',
          LastFour: '4444',
          Token: '712871f2-81f5-4a44-b269-c7e9bc41401d',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '***********0005',
          Network: 'AmericanExpress',
          ExpirationDate: '12/2029',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x0005',
          FirstSix: null,
          LastFour: null,
          Token: 'cafd9fd9-40e8-4aaa-94d6-508c3d5d6803',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '************1117',
          Network: 'Discover',
          ExpirationDate: '12/2027',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x1117',
          FirstSix: '601111',
          LastFour: '1117',
          Token: '0786ce96-9564-4fd7-b3ff-62d131944b78',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '************0000',
          Network: 'JCB',
          ExpirationDate: '12/2028',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x0000',
          FirstSix: '353011',
          LastFour: '0000',
          Token: 'fa43f978-3520-45ed-94f2-25b585f805fd',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '**********5904',
          Network: 'DinersClub',
          ExpirationDate: '12/2029',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x5904',
          FirstSix: null,
          LastFour: null,
          Token: 'f415175f-f801-4bd7-9901-d7249eaf8cc5',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
        {
          Type: 'CC',
          CardNumber: '************8453',
          Network: null,
          ExpirationDate: '12/2028',
          AVSResult: 'ExactMatch',
          CVVResult: 'Match',
          DisplayName: 'x8453',
          FirstSix: '675964',
          LastFour: '8453',
          Token: '79d61931-332f-4af2-aecd-59a42be7c645',
          NameOnAccount: 'fantazstagingdp8 fantazstagingdp8',
          BillingAddress: {
            AddressLine1: '123 Greenwood Lane',
            AddressLine2: null,
            City: 'Williston',
            StateCode: 'VT',
            PostalCode: '05495',
            CountryCode: 'US',
          },
          PhoneNumber: null,
        },
      ],

      MerchantTransactionID: '9233c023-3b25-4c3f-a9e9-da54ccd0cc55',
      MerchantID: 'VYa9_9qITEOSEvlDwvk6uQ',
      GidxURL: 'https://api.gidx-service.in/v3.0/api/',
      status: 'success',
      AmountWithFee: {
        Original: 5,
        Fee: 0.05,
        Total: 5.25,
      },
    } as TsevoDirectCashierResponse);
  }

  static completeDepositResponse(): Observable<CompleteSessionDirectCashierResponse> {
    return of({ status: 'COMPLETE', allowRetry: false });
  }

  static completeWithdrawalResponse(): Observable<CompleteSessionDirectCashierResponse> {
    return of({ status: 'PENDING', allowRetry: false });
  }

  static validateByCardResponse() {
    return of({
      status: VERIFICATION_TYPES.APPROVED as keyof typeof VERIFICATION_TYPES,
    });
  }
}
